import { render, staticRenderFns } from "./ReminderAssigneesTable.vue?vue&type=template&id=46ecfaaa&"
import script from "./ReminderAssigneesTable.vue?vue&type=script&lang=js&"
export * from "./ReminderAssigneesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports